import type { ComponentProps } from "react";

export interface OtherProducersToggleProps
	extends Omit<ComponentProps<"button">, "type" | "children"> {
	expanded: boolean;
	onToggle: () => void;
	label?: string; // allow overriding label if needed later
}

/**
 * Separator / toggle between the list of top producers and the collapsed list of other producers.
 * Collapsed by default; when clicked it toggles visibility of other producers.
 */
export function OtherProducersToggle({
	expanded,
	onToggle,
	label,
	...rest
}: OtherProducersToggleProps) {
	return (
		<button
			type="button"
			aria-expanded={expanded}
			onClick={onToggle}
			className="mt-2 mb-1 w-full text-left text-body-sm-emphasis text-ansay-main hover:text-ansay-light"
			data-testid="other-producers-toggle"
			{...rest}
		>
			{label || (expanded ? "Hide other producers" : "Show other producers")}
		</button>
	);
}
